import { useRef } from 'react'

import { useRouter } from 'next/router'

import SearchPage from '@components/search/SearchPage'

export default function Search() {
	const router = useRouter()

	const inputRef = useRef<HTMLInputElement>(null)

	return <SearchPage q={router.query.q as string} inputRef={inputRef} />
}
